import React from 'react';
import {FeedbacksData} from '../../services/type';
import {MobileFeedbackCard} from '../mobile-feedback-card';

interface Props {
    feedbacks: FeedbacksData;
}

const MobileFeedbackList = (props: Props) => {
    const {feedbacks} = props;
    const data = feedbacks.feedbacks;

    return data.map(feedback => (
        <MobileFeedbackCard key={feedback.feedbackId}
            id={feedback.feedbackId}
            feedback={feedback}
            feedbacks={feedbacks}
        />
    ));
};

export default MobileFeedbackList;
